import React from "react";
import DayPicker, { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
const  axios = require("axios");
import Cookies from "universal-cookie";

//import "./calendar-year.scss";
import { Tooltip } from "@material-ui/core";
const cookies=new Cookies();
//const bookedDays = [];
const bookedDays = [new Date(2023, 7, 8), new Date(2023, 7, 10)];
const bookedStyle = { border: '2px solid currentColor' };

const modifiers = {
  holidays: {
    [new Date(2024, 0, 1, 12)]: "New Year's Day",
    [new Date(2023, 0, 7, 12)]: "Orthodox Christmas Day",
    [new Date(2023, 0, 8, 12)]: "Women's Day"
  },
vacations: [
  {from: new Date(2024, 0, 1, 12),to: new Date(2024, 0, 1, 12), name:"mark"} ,
  {from: new Date(2024, 0, 7, 12),to: new Date(2024, 0, 7, 12), name:"mark"},
  {from: new Date(2024, 0, 8, 12),to: new Date(2024, 0, 8, 12), name:"mark"}

  ]
};

const modifiersStyles = {
  holidays: {
    background: "rgba(255, 122, 122, 0.4)"

},
  vacations: {
    background: "rgba(255, 122, 255, 0.4)"
  }
};

function renderDay(day, mod) {
  const date = day.getDate();
  const classNames = `${modifiers.holidays[day] ? "holiday" : ""}`;
  const title = modifiers.holidays[day] || "";

  return (
    <Tooltip title={title} className={classNames}>
      <div>{date}</div>
    </Tooltip>
  );
}

class Holidays extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inputdata:"",
      from: null,
      to: null
    };
  }

  componentDidMount()
  {
    axios({
      method: 'post',
      url: cookies.get("phpclass")+'/index.php/user/get_holidays/',
      headers: {'Content-Type': 'multipart/form-data'}
      })
  .then((response)=> {
      document.body.style.cursor="default";
      let data=response.data;
      let text1="";
      let text2="";
      for (var i = 0; i < data.length; i++) {
//          text1="["+ data[i]["hdate"]+"]:"+data[i]['title'];
          text1=data[i]["hdate"]+": '"+data[i]['title']+"'";
          //text2="{from:"+ data[i]["hdate"]+",to:"+ data[i]["hdate"]+", name:'mark'}";
//          Array.prototype.push.call(bookedDays,date(data[i]["hdate"]));
//          modifiers.holidays.push(text1);
 //         console.log(holidays);
         //vacations.push(text2);
          
         //let aa=data[i]["hdate"]:
          
      }
      console.log(bookedDays);
//      this.setState({holidaydates:response.data,isLoaded: true,ErrMsg:""});
    })
    .catch(function(error){
      document.body.style.cursor="default";        
 //     this.setState({ErrMsg:"",ErrMsg2: <Mymodal handler = {this.handleClear} Type="1" Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
    });      
  }    
  

  handleDayClick = day => {
    const range = DateUtils.addDayToRange(day, this.state);

    this.setState(range);
  };

  render() {
    //console.log(modifiers);
    const { from, to } = this.state;

    return (
      <div className="container1">

      <DayPicker
        className="Range"
        numberOfMonths={12}
        selectedDays={[{ from, to }]}
        modifiers={{booked:bookedDays}}
        modifiersStyles={{booked:bookedStyle}}
        onDayClick={this.handleDayClick}
        renderDay={renderDay}
        canChangeMonth={true}
      />
      </div>
    );
  }
}

export default Holidays;
